<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <DropdownColumns v-model="fields" class="customize"/>
          </div>
          <b-table
            id="permissions-table"
            :busy.sync="isBusy"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :hover="true"
            :striped="true"
            stacked="md"
            :items="permissions"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="filtered"
          >
            <template v-slot:empty="scope">
              <div class="text-center">{{ $t(scope.emptyText) }}</div>
            </template>
            <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(description)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(group)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(value)="data">{{ $t(data.label) }}</template>
          </b-table>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="loadData()"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";

export default {
  components: {
    PaginationSelect,
    DropdownColumns
  },
  name: "permissions",
  mixins: [tableMixin],
  data: function() {
    return {
      tableName: "permissions",
      isBusy: false,
      sortBy: "name",
      sortDesc: false,
      fields: [
        { key: "name", sortable: true, class: "" },
        { key: "description", sortable: true, class: "" },
        { key: "group", sortable: true, class: "" },
        { key: "value", sortable: true, class: "" }
      ],
      permissions: [],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      addLabel: ""
    };
  },
  computed: {
    filterFields() {
      return [];
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    refresh() {},
    loadData() {
      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      this.$store
        .dispatch("permissions/fetch")
        .then(resp => {
          this.totalRows = resp.data.rows.length;
          this.permissions = resp.data.rows;
        })
        .catch(err => {
          this.$bvToast.toast(
            this.$t(err.message),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          this.permissions = [];
        })
        .finally(() => {
          loader.close();
        });
    },
    redirect() {},
    filtered(items) {
      this.totalRows = items.length;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
